import type { SingleMarketTemplate, TemplateView } from '@ps/web-sports-api-types';

export const isSingleMarketTemplate = (
  template: TemplateView['template']
): template is SingleMarketTemplate => 'marketId' in template;
